export default __webpack_public_path__ + "static/media/copyinvite.41b44233.svg";